import styled from "styled-components";
import { Flex, Popover } from "discover.medical.react-component-library";

//TODO: this will be removed once new assistant is deployed
export const AssistantPopover = styled(Popover)`
  z-index: 100;
  .AssistantPopper > div > div {
    padding: 0;
  }

  .AssistantPopper {
    &[data-popper-placement="top"] {
      padding-bottom: 0.375rem;
    }
  }
  @media (min-width: ${(props) => props.theme.breakpoints.sm}) {
    .AssistantPopper {
      &[data-popper-placement="top"] {
        padding-bottom: 1.45rem;
      }
    }
  }
`;

export const AuthErrorMsg = styled(Flex)`
  margin: auto;
  padding: 4rem 2rem;
`;

export const AssistantContainer = styled.div`
  display: none;
  height: 1800px;
  overflow: hidden;
  flex: 1 0 auto;
  margin: 4rem 1rem 2rem;

  @media (min-width: ${(props) => props.theme.breakpoints.sm}) {
    height: 1400px;
    margin: 7rem 4rem 2rem;
  }

  /* this needs to change at min-width 890px because where the popular search wraps */
  @media (min-width: 890px) {
    height: 900px;
  }

  @media (min-width: 1040px) {
    margin: 11rem 10rem 2rem;
  }

  ${({ $isVisible }) =>
    $isVisible &&
    `
    display:block;
    ~ #main-content {
      display: none;
    }
  `};
`;

export const AssistantIFrame = styled.iframe`
  width: 100%;
  height: 100%;
`;
